import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  convertDetailsToAttributes,
  headerAttributes as getHeaderAttributes
} from '@verzekeringapp-mono/shared/src/utils/policy_utils'
import { IPolicy } from '@verzekeringapp-mono/shared/src/models/policy'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getResourceAuthorization } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'
import { getProductIcons } from '@verzekeringapp-mono/shared/src/state/selectors/policies'

interface IProps {
  policy: IPolicy
}

const PolicyDetailHeader: React.FC<IProps> = ({ policy }) => {
  const headerAttributes = convertDetailsToAttributes(
    getHeaderAttributes(policy)
  )

  const resourceAuthorization = useAppSelector(getResourceAuthorization)
  const productIcons = useAppSelector(getProductIcons)

  return (
    <div className='flex flex-col gap-8 rounded bg-surface-card'>
      <div className='flex flex-col gap-4'>
        <div className='justify-between flex flex-row'>
          <div className='flex flex-row'>
            <div className='mr-4 flex h-[50px] w-[50px] items-center justify-center rounded-full bg-surface-brand-subtle text-icon-brand'>
              <FontAwesomeIcon
                icon={productIcons[policy.productId]}
                size='lg'
                className='text-icon-brand'
              />
            </div>

            <div>
              <p className='subtitle text-text-brand'>{policy.productName}</p>

              <p className='light text-sm'>{`Polisnummer: ${policy.policyNumber}`}</p>
            </div>
          </div>

          {policy.premium && policy.status === 'Lopend' && (
            <div className='flex flex-col'>
              <p className='text-right text-lg font-semibold text-text-brand'>
                {Intl.NumberFormat('nl-NL', {
                  style: 'currency',
                  currency: 'EUR'
                }).format(Number(policy.premium))}
              </p>

              <span className='text-sm light'>
                {(!!resourceAuthorization?.relationInfo?.paymentPeriod && policy.paymentMethod !== 'one_time') && ` per ${resourceAuthorization.relationInfo?.paymentPeriod.toLowerCase()}`}

                {(policy.paymentMethod === 'one_time') && ' eenmalig'}
              </span>
            </div>
          )}

          {(policy.status === 'Opgeschort' || policy.status === 'Toekomstig') && (
            <p className='text-sm text-text-muted'>{policy.status === 'Opgeschort' ? 'Opgeschort' : 'Toekomstig'}</p>
          )}
        </div>
      </div>

      <div className='grid md:grid-cols-4 gap-4 grid-cols-2'>
        {headerAttributes.map((attribute) => (
          <div key={attribute.id}>
            <p className='text-sm light'>{attribute.title}</p>

            <p className='text-base text-text-primary'>{attribute.description}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PolicyDetailHeader
